exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.product-add[data-v-407ff5fb]{padding-bottom:50px\n}", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_supplier/src/views/product/product/edit.vue"],"names":[],"mappings":";AACA,8BAA8B,mBAAmB;CAChD","file":"edit.vue","sourcesContent":["\n.product-add[data-v-407ff5fb]{padding-bottom:50px\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-407ff5fb","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_supplier/src/styles/variables.scss","/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_supplier/src/styles/mixin.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/product/product/edit.vue
// module id = mhKA
// module chunks = 0